import { CityState, DataSource, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelTransactionDetail extends Layout {
    citystateLocation: CityState;
    citystateTruckStop: CityState;
    labelDirectTotalCaption: Label;
    labelEquipmentTitle: Label;
    labelFeesAndTaxesTitle: Label;
    labelFundedTotalCaption: Label;
    labelNonFuelTotalsTitle: Label;
    labelOverview: Label;
    labelProductCodesTitle: Label;
    labelProductCodesTotalValue: Label;
    labelSubTotal: Label;
    labelTableFuelTotalsTitle: Label;
    labelTotalDueSpacer: Label;
    labelTransAmountsTitle: Label;
    labelTripInfoTitle: Label;
    labelTruckStopTitle: Label;
    panelEquipment: Panel;
    panelFeesAndTaxes: Panel;
    panelFeesAndTaxesDetail: Panel;
    panelFeesAndTaxesTitle: Panel;
    panelFuelTotals: Panel;
    panelFuelTotalsTable: Panel;
    panelFuelTotalsTitle: Panel;
    panelLeft: Panel;
    panelNonFuelTotals: Panel;
    panelNonFuelTotalsDetail: Panel;
    panelNonFuelTotalsTitle: Panel;
    panelOverview: Panel;
    panelProductCodes: Panel;
    panelProductCodesSubTotal: Panel;
    panelRight: Panel;
    panelTransAmounts: Panel;
    panelTransAmountsDetail: Panel;
    panelTransAmountsTitle: Panel;
    panelTransTotals: Panel;
    panelTripInfo: Panel;
    panelTruckStop: Panel;
    sourceFuelDetail: DataSource;
    sourceFuelProducts: DataSource;
    switchHold: Switch;
    tableFeesAndTaxes: Table;
    tableFuelTotals: Table;
    tableNonFuelTotals: Table;
    tableProductCodes: Table;
    textboxAllianceNetworkLocation: Textbox;
    textboxChainCode: Textbox;
    textboxDirectAmount: Textbox;
    textboxDriverName: Textbox;
    textboxFuelBillCode: Textbox;
    textboxFuelCardId: Textbox;
    textboxFuelCardpayeeId: Textbox;
    textboxFundedAmount: Textbox;
    textboxInLimitedNetwork: Textbox;
    textboxInterfaceId: Textbox;
    textboxLicenseNo: Textbox;
    textboxLicensedState: Textbox;
    textboxMasterAccountNo: Textbox;
    textboxMovementId: Textbox;
    textboxOrderId: Textbox;
    textboxPoNumber: Textbox;
    textboxPrevHub: Textbox;
    textboxProviderEmpNo: Textbox;
    textboxSubAccountNo: Textbox;
    textboxTractorHub: Textbox;
    textboxTractorId: Textbox;
    textboxTrailerHub: Textbox;
    textboxTrailerId: Textbox;
    textboxTransDateTime: Textbox;
    textboxTransNo: Textbox;
    textboxTransType: Textbox;
    textboxTransactionStatus: Textbox;
    textboxTruckStopCode: Textbox;
    textboxTruckStopName: Textbox;
}
